import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import store from './store';
import App from './pages/location-search.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

// init app
const el = document.querySelector('#location-search');
if (el) {
	new Vue({
		store,
		components: {
			app: App,
		},
	}).$mount('#location-search');
}
